import { defineComponent as _defineComponent } from 'vue'
interface IProps {
  strokeColor?: string;
  size?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconTextoNorma',
  props: {
    strokeColor: { default: '#FFFFFF' },
    size: { default: 24 }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})